import { Button } from '@mui/material';

import { useSite } from '@labradorsports/utils';

import { ContentViewer } from '../../form/index.js';

interface Props {
    person: Personnel;
    onDelete?: AnyFunction;
    onEdit?: (personnel: Personnel) => void;
    viewFilm?: (personnel: Personnel) => void;
    readOnly?: boolean;
}

const PersonnelCard: FC<Props> = ({ person, onDelete, onEdit, viewFilm, readOnly = false }) => {
    const { Config } = useSite();

    return (
        <div className="personnel-card card w-100">
            <div className="d-flex">
                <div className="flex-grow-1 me-2">
                    <div className="field-header">Player</div>
                    <em>
                        {[person.jersey ? `#${person.jersey}` : '', person.name ? `- ${person.name}` : ''].join(' ')}
                    </em>
                </div>
                {person.matchup ? (
                    <div>
                        <div className="field-header">Matchup</div>
                        <span>{person.matchup}</span>
                    </div>
                ) : null}
            </div>
            <div className="small text-muted">{person.position ?? ''}</div>
            <div className="my-2">
                <ContentViewer key={person.description} value={person.description} />
            </div>
            <div>
                <div className="field-header">Stats</div>
                {Config.PersonnelQuickStats.filter((stat) => Boolean(person.stats?.[stat]))
                    .map((stat) => `${Config.ScoutingReportStatDetails[stat].shortKey}: ${person.stats[stat]}`)
                    .join(', ')}
            </div>
            <div className="text-end">
                {person.filmUrl && viewFilm ? <Button onClick={() => viewFilm(person)}>Watch Film</Button> : null}
                {!readOnly ? (
                    <>
                        <Button onClick={() => onEdit(person)}>Edit</Button>
                        <Button
                            onClick={() => onDelete(person)}
                            style={{
                                color: '#dc3545',
                            }}
                        >
                            Remove
                        </Button>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default PersonnelCard;
